var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('jet-map',{ref:"map",attrs:{"name":"mapbox-provider"},on:{"onload":_vm._mapLoad}})}
var staticRenderFns = []

export { render, staticRenderFns }